import { configureStore } from '@reduxjs/toolkit';
import buildingReducer from './societyData'; // Ensure the correct file name is used

export const store = configureStore({
    reducer: {
        buildingMaster: buildingReducer, // Properly referenced reducer
        
    },
});

export default store;